import { createTheme } from '@material-ui/core/styles';
import { colors } from './color-palette';

// eslint-disable-next-line prettier/prettier
const { PURPLE, WHITE, BlACK, PURPLE_INACTIVE, ERROR, LIGHT_PURPLE, TOGGLE_ACTIVE, GREY } = colors;

export const theme = createTheme({
	palette: {
		primary: {
			main: PURPLE
		}
	},
	overrides: {
		MuiTableCell: {
			root: {
				padding: '0px 16px !important',
				height: '40px',
				fontFamily: 'Bogle-Medium'
			}
		},
		MuiCheckbox: {
			root: {
				color: '#3B3B3B'
			},
			colorPrimary: {
				'&$disabled': {
					color: PURPLE_INACTIVE
				},
				'&$checked': {
					'&:hover': {
						backgroundColor: '#F5F5F5'
					}
				}
			}
		},
		MuiPaginationItem: {
			root: {
				'&$selected': {
					backgroundColor: `${WHITE} !important`,
					color: `${PURPLE} !important`,
					border: `1px solid ${PURPLE}`,
					'&:hover': {
						backgroundColor: LIGHT_PURPLE
					}
				}
			}
		},
		MuiTypography: {
			root: {
				fontFamily: 'Bogle-Regular !important'
			}
		},
		MuiAppBar: {
			colorPrimary: {
				color: BlACK,
				backgroundColor: WHITE
			}
		},
		MuiAccordion: {
			root: {
				'&.Mui-expanded': {
					margin: 0,
					minHeight: '50px!important'
				},
				'&::before': {
					backgroundColor: 'unset'
				}
			},
			rounded: {
				boxShadow: '0px 0px'
			}
		},
		MuiAccordionDetails: {
			root: {
				display: 'block',
				padding: 0
			}
		},
		MuiIconButton: {
			root: { padding: 0 }
		},
		MuiButton: {
			text: {
				textTransform: 'unset'
			}
		},
		MuiTextField: {
			root: {
				'& .Mui-error': {
					color: ERROR
				},
				'& .MuiFormHelperText-root': {
					color: ERROR
				}
			}
		},
		MuiChip: {
			root: {
				borderRadius: 2
			},
			outlined: {
				border: 0,
				backgroundColor: '#F2F2F2'
			}
		},
		MuiListItem: {
			root: {
				'&.Mui-disabled': {
					opacity: '0.5',
					pointerEvents: 'none'
				}
			},
			button: {
				'&:hover': {
					backgroundColor: TOGGLE_ACTIVE
				}
			}
		},
		MuiInputBase: {
			input: {
				'&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
					'-webkit-appearance': 'none',
					display: 'none'
				}
			}
		},
		MuiMenuItem: {
			root: {
				minHeight: '40px !important',
				maxHeight: 'auto',
				minWidth: '175px !important'
			}
		},
		MuiAutocomplete: {
			option: {
				paddingTop: 0,
				paddingBottom: 0,
				'&[aria-selected="true"]': {
					backgroundColor: 'transparent'
				},
				'&:hover': {
					backgroundColor: '#F2F2F2'
				}
			}
		},
		MuiSnackbarContent: {
			root: {
				backgroundColor: '#EBE8F3'
			},
			message: {
				color: '#333333',
				fontSize: 14,
				fontFamily: 'Bogle-Regular',
				fontWeight: 400
			}
		},
		MuiListItemIcon: {
			root: {
				minWidth: 40
			}
		}
	}
});

export const cssVariables = {
	container: {
		width: 350,
		height: 280
	},
	day: {
		fontSize: 12
	}
};

export const themedCheckbox = {
	marginRight: '12px',
	marginLeft: '26px',
	color: GREY,
	padding: '0 !important',
	'&:hover': {
		backgroundColor: 'unset !important'
	},
	'& .MuiSvgIcon-root': {
		height: '16px',
		width: '16px'
	},
	'&.Mui-checked': {
		'&:hover': {
			backgroundColor: 'unset !important'
		},
		color: PURPLE
	}
};
